import { render } from "./NewStaff.vue?vue&type=template&id=a798c9b8&scoped=true"
import script from "./NewStaff.vue?vue&type=script&lang=js"
export * from "./NewStaff.vue?vue&type=script&lang=js"

import "./NewStaff.vue?vue&type=style&index=0&id=a798c9b8&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a798c9b8"]])

export default __exports__